export default __webpack_public_path__ + "static/media/arkan-gerges.f85bd44b.png";